export const getDefaultFormat = (options = {}) => ({
  fontSize: options.fontSize || '14px',
  bold: options.bold || false,
  italic: options.italic || false,
  underline: options.underline || false,
  textColor: options.textColor || 'inherit',
});
